import { render, staticRenderFns } from "./IndicatorSettingsSection.vue?vue&type=template&id=3dd5eb2c&scoped=true"
import script from "./IndicatorSettingsSection.vue?vue&type=script&lang=js"
export * from "./IndicatorSettingsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd5eb2c",
  null
  
)

export default component.exports